(function() {
  if (window.location.pathname !== '/pages/groove_feedback') return;
  
  var scriptUrl = 'https://script.google.com/macros/s/AKfycbzXSEI4JLa_gTiKwWSbL0zdWvRhxwo9Y_Lf44XTWrebZ-hoZv9EcKwJ6FtZ8In9WtFAcQ/exec';
  var urlParams = new URLSearchParams(window.location.search);
  var rating = urlParams.get('rating');
  
  if (!rating) return;
  
  fetch(scriptUrl + '?rating=' + rating, { mode: 'no-cors' })
    .finally(function() {
      window.location.href = 'https://luxire.com';
    });
})();